import authCentral, {getOauthLink, perculator} from "../../../services/authCentral";
import useOriginApp from "../../../services/useOriginApp";

export default function useFormSubmit(setLoginError){
    const originApp = useOriginApp();
    
    return async function(data){
        const {username, sesame1} = data; 
        setLoginError(false);

        //In many cases we see users enter here their medstar ids/emails. We will check it here and redirect to SSO
        //if user tries to use a medstar email here
        if(username.indexOf('@medstar.net') > 1 || username.indexOf('@gunet.georgetown.edu') > 1){
            window.location.href = getOauthLink(originApp.path);

        } else {
            await authCentral.loadJWTFromServer('sg-atlantis', '', {username, sesame1: perculator(sesame1)});
            const user = authCentral.getCurrentUser();
            if(user){
                setLoginError(false);
                window.location.href = originApp.url;
            } else {
                setLoginError(true);
            }

        }
    }
}
